import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class UserService {
  baseUrl = 'user';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getLanguageList = () => BaseService.get({ url: `${this.baseUrl}/get-language-list` });
  getTimeZoneList = () => BaseService.get({ url: `${this.baseUrl}/get-time-zone-list` });
  getDateFormatList = () => BaseService.get({ url: `${this.baseUrl}/get-date-format-list` });
  getDecimalSeparatorList = () => BaseService.get({ url: `${this.baseUrl}/get-decimal-sep-list` });
  getThousandSeparatorList = () => BaseService.get({ url: `${this.baseUrl}/get-thousand-sep-list` });
  getSignatureImage = (userId, signatureId) => BaseService.get({ url: `${this.baseUrl}/get-signature-img/${userId}/${signatureId}`});
  displaySignatureImage = (userId, signatureId) => Utils.file.attachment.get(`${this.baseUrl}/display-signature-img/${userId}/${signatureId}`);
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (user) => BaseService.post({ url: `${this.baseUrl}/save`, data: user });
  import = (userImport) => BaseService.post({ url: `${this.baseUrl}/import`, data: userImport });
  activate = (id) => BaseService.post({ url: `${this.baseUrl}/activate/${id}` });
  recoverPassword = (email) => BaseService.post({ url: 'account/recover-password', data: `=${email}` });
  recoverDevice = (email) => BaseService.post({ url: 'account/recover-device', data: `=${email}` });
  restoreDevice = (id, deviceId) => BaseService.post({ url: `account/restore-device/${id}/${deviceId}` });
  samlRequest = () => BaseService.get({ url: 'account/sso/saml2/request' });
  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  getSignaturesList = () => BaseService.get({ url: `${this.baseUrl}/signatures-list` });
  checkRights = () => BaseService.get({ url: `${this.baseUrl}/check-report-rights` });
}

export default new UserService()
